"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaPreviewState = void 0;
var MediaPreviewState;
(function (MediaPreviewState) {
    MediaPreviewState["NotAvailable"] = "notAvailable";
    MediaPreviewState["SentToGenerator"] = "sentToGenerator";
    MediaPreviewState["Processing"] = "processing";
    MediaPreviewState["Available"] = "available";
    MediaPreviewState["Error"] = "error";
})(MediaPreviewState = exports.MediaPreviewState || (exports.MediaPreviewState = {}));
//# sourceMappingURL=media-preview-state.js.map